<script>
  import { Images } from '@client/pages/brandkit/components';

  /** @type {boolean} */
  export let active = false;
  /** @type {(e: DragEvent, url: string) => void} */
  export let onDragStart = () => {};

  const handleDragStart = (e, url) => {
    onDragStart(e, `{{ "${url}" | img }}`);
  };
</script>

<Images {active} draggable onDragStart={handleDragStart} minWidth={200} minHeight={100} />
